export function buildLink(statusEntry) {
  if (statusEntry?.type === 'ContentfulConfig') {
    // This is a contentful entry
    return `https://app.contentful.com/spaces/${statusEntry.entry.sys.space.sys.id}/environments/${statusEntry.entry.sys.environment.sys.id}/entries/${statusEntry.entry.sys.id}`
  } else if (statusEntry?.type === 'MOALContent') {
    // this is a moalpress entry
    // for now return the same as wp does. this is helpful to get us to the admin dashboard for troubleshooting
    return statusEntry?.data?.link
  } else {
    // This is wordpress
    return statusEntry?.data?.link
  }
}
